import classNames from "classnames";
import { ReactNode, useRef } from "react";
import { Icon } from "../icon/icon";

export const Checkbox = ({
  checkStatus,
  handleChange = () => {},
  text = "",
  textPosition = "right",
  className = "right",
  disabled = false,
  checkDimension = 16,
  textClassName = "",
  hideIconUntilSelect = false,
}: {
  checkStatus: boolean;
  disabled?: boolean;
  handleChange: (status: boolean) => void;
  text?: ReactNode;
  textPosition?: "left" | "right";
  className?: string;
  checkDimension?: number;
  textClassName?: string;
  hideIconUntilSelect?: boolean;
}) => {
  const checkBoxRef = useRef<HTMLInputElement | null>(null);

  return (
    <button
      type="button"
      className={`flex w-fit items-center gap-[10px] disabled:cursor-not-allowed ${className} `}
      onClick={() => {
        checkBoxRef?.current?.click();
      }}
      disabled={disabled}
    >
      <Icon
        svg={checkStatus ? "checkbox-active" : "checkbox-inactive"}
        width={checkDimension}
        height={checkDimension}
        className={classNames("w-fit", {
          hidden: hideIconUntilSelect && !checkStatus,
        })}
      />
      <div
        className={classNames(
          "block text-sm font-bold",
          {
            "order-last": textPosition === "right",
            "order-first": textPosition === "left",
          },
          textClassName,
        )}
      >
        {text}
      </div>

      <input
        type="checkbox"
        className="hidden"
        ref={checkBoxRef}
        checked={checkStatus}
        onChange={(e) => {
          handleChange(!checkStatus);
        }}
        disabled={disabled}
      />
    </button>
  );
};
